exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".header---2MqcN{position:relative;width:100%;height:50px;padding:5px 0;font-size:1.6em}.footer---3rHEW{font-size:1.6em}", ""]);

// exports
exports.locals = {
	"header": "header---2MqcN",
	"footer": "footer---3rHEW"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoaders=1&modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader!./~/sass-loader!./~/sass-resources-loader/lib/loader.js!./src/app/views/app/appView.scss
// module id = 1020
// module chunks = 0